import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, CheckSquare, FileText, AlertTriangle, FolderOpen } from 'lucide-react';
import { cn } from '../../lib/utils';
export function BottomNav() {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  // Sesuai requirements: Dashboard, Checklist, Laporan, Isu, Materi
  const navItems = [{
    name: 'Dashboard',
    path: '/officer',
    icon: LayoutDashboard
  }, {
    name: 'Checklist',
    path: '/officer/checklist',
    icon: CheckSquare
  }, {
    name: 'Laporan',
    path: '/officer/laporan',
    icon: FileText,
    isCenter: true
  }, {
    name: 'Isu',
    path: '/officer/isu',
    icon: AlertTriangle
  }, {
    name: 'Materi',
    path: '/officer/materi',
    icon: FolderOpen
  }];
  return <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 pb-safe" data-id="element-275">
      <div className="flex items-center justify-around h-16 px-2" data-id="element-276">
        {navItems.map(item => {
        const Icon = item.icon;
        const active = isActive(item.path);
        if (item.isCenter) {
          return <Link key={item.path} to={item.path} className="relative -top-5 flex flex-col items-center justify-center" data-id="element-277">
                <div className={cn('h-14 w-14 rounded-full flex items-center justify-center shadow-lg transition-transform active:scale-95', active ? 'bg-primary-700 text-white ring-4 ring-primary-100' : 'bg-primary-600 text-white')} data-id="element-278">
                  <Icon className="h-6 w-6" data-id="element-279" />
                </div>
                <span className={cn('text-[10px] font-medium mt-1', active ? 'text-primary-700' : 'text-gray-500')} data-id="element-280">
                  {item.name}
                </span>
              </Link>;
        }
        return <Link key={item.path} to={item.path} className="flex flex-col items-center justify-center w-full h-full space-y-1 active:bg-gray-50" data-id="element-281">
              <Icon className={cn('h-6 w-6 transition-colors', active ? 'text-primary-600' : 'text-gray-400')} data-id="element-282" />
              <span className={cn('text-[10px] font-medium transition-colors', active ? 'text-primary-600' : 'text-gray-500')} data-id="element-283">
                {item.name}
              </span>
            </Link>;
      })}
      </div>
    </nav>;
}